uniform vec2 resolution;
uniform float time;
varying vec2 vUv;

float sdCircle(vec2 p, float r) {
    return length(p) - r;
}

float remap(float x, float a, float b, float c, float d) {
    return c + (x - a) * (d - c) / (b - a);
}

float getDot(float offset, float scale) {
    vec2 uv = vUv - vec2(0.5) + vec2(time);
    vec2 screenCoords = (uv) * resolution;

    float t = mod(offset + time * uv.x * uv.y * 100., 60.) * scale;

    float cellSize = remap(sin((t) * 0.01), -1., 1., 60., 320.);

    vec2 p = mod(screenCoords, cellSize) - (cellSize / 2.);
    float r = remap(sin(time * 0.001), -1., 1., cellSize / 2., cellSize / 4.);
    float x = sdCircle(p, r);
    return x;
}

void main() {

    gl_FragColor = vec4(getDot(50., 1.), getDot(40., 0.3), getDot(0.,0.125), 1.0);
}